const environment = {
  production: true,
  name: 'production',
  apis: {
    studentPortalApi: {
      endpoint:
        'https://dit-stuapp-frontdoor-endpoint-prod-d5hjhbhcfadkc7ft.z01.azurefd.net/api',
      scopes: ['api://student-portal-prod/Portal.View'],
    },
    graphApi: {
      endpoint: 'https://graph.microsoft.com/v1.0',
      scopes: ['User.Read'],
    },
  },
  appInsights: {
    connectionString:
      'InstrumentationKey=8ab826c2-aacb-49ca-b859-e35cff4f513a;IngestionEndpoint=https://uksouth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/',
  },
};

export default environment;
